module.exports = __webpack_public_path__ + "static/media/full_gear_standing.44a7efa6.jpg";